import { TablePagination } from '@all-manager/design-system-v2';
import { DOCUMENTS_PAGE_SIZE_OPTIONS } from '../../constants/pagination';

type Props = {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

function formatDisplayedRows(info: { from: number; to: number; count: number }) {
  return `${info.from}–${info.to} sur ${info.count}`;
}

export default function DocumentsPagination(props: Props) {
  return (
    <TablePagination
      count={props.count}
      page={props.page}
      rowsPerPage={props.rowsPerPage}
      rowsPerPageOptions={DOCUMENTS_PAGE_SIZE_OPTIONS}
      onPageChange={props.onPageChange}
      onRowsPerPageChange={props.onRowsPerPageChange}
      labelRowsPerPage="Par page"
      labelDisplayedRows={formatDisplayedRows}
      getItemAriaLabel={(type) => (type === 'next' ? 'Page suivante' : 'Page précédente')}
    />
  );
}
